// custom shipping bar 

const ShippingBar = (() => {
  const bar = document.querySelector('.shipping-bar');

  let promoteTxt, unlockedTxt, threshold, shippingQuotient, shippingPercent;
  let promoteTxt_ca, unlockedTxt_ca, threshold_ca, shippingQuotient_ca, shippingPercent_ca;

  if (bar) {
    promoteTxt = bar.dataset.promote;
    unlockedTxt = bar.dataset.unlocked;
    threshold = bar.dataset.threshold;
    shippingQuotient = bar.dataset.quotient;
    shippingPercent = bar.dataset.procent;
// canada
    promoteTxt_ca = bar.dataset.promote;
    unlockedTxt_ca = bar.dataset.unlocked;
    threshold_ca = bar.dataset.threshold;
    shippingQuotient_ca = bar.dataset.quotient;
    shippingPercent_ca = bar.dataset.procent;
  }

  const update = () => {
    
    if (bar) {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          shippingPercent = cart.total_price / shippingQuotient;
          const valueLeft = threshold - cart.total_price;
          const valueLeftMoney = theme.Currency.formatMoney(valueLeft, theme.moneyFormat);

          // canada 
          shippingPercent_ca = cart.total_price / shippingQuotient_ca;
          const valueLeft_ca = threshold_ca - cart.total_price;
          const valueLeftMoney_ca = theme.Currency.formatMoney(valueLeft_ca, theme.moneyFormat);
          

          if (valueLeft <= 0) {
            bar.innerHTML =
              '<div class="free-shipping__progress progress-success" style="width:' +
              shippingPercent +
              '% ">' +
              '</div>' +
              '<p class="shipping-bar-success shipping-bar__message">' +
              unlockedTxt +
              '</p>';
          } else {
            bar.innerHTML =
              '<div class="free-shipping__progress" style="width:' +
              shippingPercent +
              '% ">' +
              '</div>' +
              '<p class="shipping-bar__message">' +
              promoteTxt.replace('[value]', valueLeftMoney) +
              '</p>';
          }

           // canada 
          if (valueLeft_ca <= 0) {
            bar.innerHTML =
              '<div class="free-shipping__progress_ca progress-success" style="width:' +
              shippingPercent_ca +
              '% ">' +
              '</div>' +
              '<p class="shipping-bar-success shipping-bar__message">' +
              unlockedTxt_ca +
              '</p>';
          } else {
            bar.innerHTML =
              '<div class="free-shipping__progress_ca" style="width:' +
              shippingPercent_ca +
              '% ">' +
              '</div>' +
              '<p class="shipping-bar__message">' +
              promoteTxt_ca.replace('[value]', valueLeftMoney_ca) +
              '</p>';
          }
          // end canada 
        });
    }
  };

  return;
})();
